import useContract from "hooks/useContract";
import { abi as PayTokenAbi } from "constants/abis/pay-token.abi.json";

export function usePayTokenContract(token: string) {
  return useContract(token, PayTokenAbi);
}
